import axios from 'axios';
import config from 'config';

export const sendError = async (message, stackTrace, route) => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${config.api.authenticator}/error`,
      data: {
        message,
        stacktrace: stackTrace,
        route,
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export default {
  sendError,
};
